import React, { Fragment } from "react";
import Link from "./link";

const PageHeaderThree = ({ title, name }) => {
  return (
    <section className="breadcrumb_section bg3 text-center section_padding">
      <ul className="breadcrumb">
        <li>
          <Link href="/">Home</Link>
        </li>
        <li>{name}</li>
      </ul>
      <h1 >{title}</h1>
    </section>
  );
};

export default PageHeaderThree;
